import { alpha, createTheme } from '@mui/material/styles';

import type { ColorMode } from './colorMode';

declare module '@mui/material/styles' {
    interface Palette {
        chip: {
            mirror: { bg: string; text: string };
            independent: { bg: string; text: string };
        };
    }
    interface PaletteOptions {
        chip?: {
            mirror?: { bg: string; text: string };
            independent?: { bg: string; text: string };
        };
    }
}

const primaryColor = {
    light: '#1a237e',
    dark: '#7986cb'
};

const darkModeSemanticColors = {
    info: { main: '#29b6f6' },
    warning: { main: '#ffb74d' },
    error: { main: '#ef5350' },
    success: { main: '#81c784' }
};

const chipPalette = {
    light: {
        mirror: { bg: '#e3f2fd', text: '#1976d2' },
        independent: { bg: '#fff3e0', text: '#e65100' }
    },
    dark: {
        mirror: { bg: '#0d3055', text: '#90caf9' },
        independent: { bg: '#4e2200', text: '#ffcc80' }
    }
};

export function createLediumTheme(mode: ColorMode) {
    const dark = mode === 'dark';
    return createTheme({
        palette: {
            mode,
            primary: { main: primaryColor[mode] },
            secondary: { main: '#f50057' },
            chip: chipPalette[mode],
            ...(dark ? darkModeSemanticColors : {})
        },
        typography: {
            fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
            h1: { marginTop: 30, fontSize: 30 },
            h2: { fontSize: 24 },
            h3: { fontSize: 20 },
            body1: { fontSize: 16 }
        },
        ...(dark && {
            components: {
                MuiAlert: {
                    styleOverrides: {
                        standardInfo: {
                            backgroundColor: alpha('#29b6f6', 0.15),
                            color: '#b3e5fc'
                        },
                        standardWarning: {
                            backgroundColor: alpha('#ffb74d', 0.15),
                            color: '#ffe082'
                        },
                        standardError: {
                            backgroundColor: alpha('#ef5350', 0.15),
                            color: '#ffcdd2'
                        },
                        standardSuccess: {
                            backgroundColor: alpha('#81c784', 0.15),
                            color: '#c8e6c9'
                        }
                    }
                }
            }
        })
    });
}
